import { useEffect, useMemo } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import { installAxiosAuth } from "@/lib/axiosAuth";

installAxiosAuth();
import { AuthPage } from "@/pages/AuthPage";
import { PaywallPage } from "@/pages/PaywallPage";
import Console from "@/pages/Console";

function isAccessAllowed(user, subscribed) {
  if (subscribed) return true;
  if (!user) return false;
  if (user.role === "admin") return true;
  if (user.subscription_active) return true;
  if (user.trial_ends_at) {
    try {
      return new Date(user.trial_ends_at) > new Date();
    } catch {
      return false;
    }
  }
  return false;
}

function Router() {
  const { user, subscribed, loading } = useAuth();
  const allowed = useMemo(() => isAccessAllowed(user, subscribed), [user, subscribed]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black grid place-items-center">
        <div className="text-zinc-400 font-mono text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <AuthPage />;
  if (!allowed) return <PaywallPage />;
  return <Console />;
}

function App() {
  useEffect(() => {
    if (document.getElementById("razorpay-script")) return;
    const s = document.createElement("script");
    s.id = "razorpay-script";
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" richColors />
      <Router />
    </AuthProvider>
  );
}

export default App;
